import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type MarketHeatmapController from 'lumen/controllers/market/heatmap';
import getEnv from 'lumen/helpers/get-env';

interface MarketHeatmapSignature {
  Args: {
    controller: MarketHeatmapController;
    model: unknown;
  };
}

<template>
  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-portfolios"
    @query={{@controller.extendedQueryParams}}
    @url={{if
      @controller.hotelAndMarketService.isMyHotels
      "/dashboards/executive/heatmap"
      (concat "/dashboards/portfolio-snapshot/" @controller.model.id "/heatmap")
    }}
  />
</template> satisfies TOC<MarketHeatmapSignature>;
